import queryString from 'query-string';
import { ACTION_TYPES, FAV_SORT_OPTIONS } from '../Constants';

const initialState = {
  startDropdownIsOpen: true,
  feedbackModalIsOpen: false,

  navbar: {
    activeTab: '',
    isLoading: false,
    isOpen: false,
  },

  commuteModalIsOpen: false,
  mapSatelliteVisible: false,
  hamburgerMenu: true,
  showContactNotification: false,
  filterToggles: {
    housingToggles: { 1: false, 2: false },
    commuteTimeQuery: {
      time: 0,
      filterOptions: {
        driving: false,
        transit: false,
        bicycling: false,
        walking: false,
      },
    },
  },
  favSortOption: FAV_SORT_OPTIONS.VICINITY,
  gotCommuteForAreas: false,
  preview: !!queryString.parse(window.location.search).preview,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.FEEDBACK_MODAL_OPENED:
      return {
        ...state,
        feedbackModalIsOpen: true,
      };
    case ACTION_TYPES.FEEDBACK_MODAL_CLOSED:
      return {
        ...state,
        feedbackModalIsOpen: false,
      };
    case ACTION_TYPES.START_DROPDOWN_OPENED:
      return {
        ...state,
        startDropdownIsOpen: true,
      };
    case ACTION_TYPES.START_DROPDOWN_CLOSED:
      return {
        ...state,
        startDropdownIsOpen: false,
      };
    case ACTION_TYPES.NAVBAR_CLOSED:
      return {
        ...state,
        navbar: {
          ...state.navbar,
          isOpen: false,
        },
      };
    case ACTION_TYPES.NAVBAR_OPENED:
      return {
        ...state,
        navbar: {
          ...state.navbar,
          isOpen: true,
        },
      };
    case ACTION_TYPES.NAVBAR_SPINNER_TOGGLED:
      return {
        ...state,
        navbar: {
          ...state.navbar,
          isLoading: action.loading,
        },
      };
    case ACTION_TYPES.NAVBAR_TAB_CHANGED:
      return {
        ...state,
        navbar: {
          ...state.navbar,
          activeTab: action.tab,
        },
      };
    case ACTION_TYPES.COMMUTE_MODAL_OPENED:
      return {
        ...state,
        commuteModalIsOpen: true,
      };
    case ACTION_TYPES.COMMUTE_MODAL_CLOSED:
      return {
        ...state,
        commuteModalIsOpen: false,
      };
    case ACTION_TYPES.TOGGLE_MAP_LAYER:
      return {
        ...state,
        mapSatelliteVisible: !state.mapSatelliteVisible,
      };
    case ACTION_TYPES.TOGGLE_HAMBURGER_MENU:
      return {
        ...state,
        hamburgerMenu: action.visible,
      };
    case ACTION_TYPES.TOGGLE_CONTACT_NOTIFICATION:
      return {
        ...state,
        showContactNotification: action.state,
      };
    case ACTION_TYPES.TOGGLE_FILTER_STATE:
      return {
        ...state,
        filterToggles: action.filterToggles,
      };
    case ACTION_TYPES.TOGGLE_FILTER_EXPANDED:
      return {
        ...state,
        filterToggles: { ...state.filterToggles, expandToggles: action.expandToggles },
      };
    case ACTION_TYPES.CHANGE_FAV_SORT_OPTION:
      return {
        ...state,
        favSortOption: action.sortOption,
      };
    case ACTION_TYPES.TOGGLE_GOT_COMMUTE_FOR_AREAS:
      return {
        ...state,
        gotCommuteForAreas: action.flag,
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/Reducers/ToggleReducer.js